import { useParams } from 'react-router';

import { getLogo } from './utils';

export function LogoLarge() {
  const { group = '' } = useParams();
  const logo = getLogo({ group, size: 'large' });

  return <img src={logo} width="120" />;
}
